import { useCallback } from 'react'
import { useGetQuery } from '../useGetQuery'
import { usePostQuery } from '../usePostQuery'

export const useTagSearch = () => {
  const { data, setPath, setEnabled } = useGetQuery({ enabled: false, url: '/tags?q=' })

  const search = useCallback((term) => {
    if (!term) { setEnabled(false); return }
    setEnabled(true)
    setPath(`/tags?q=${encodeURIComponent(term)}`)
  }, [setEnabled, setPath])

  return { tags: data?.tags?.rows || [], search }
}

export const useAssignTag = () => {
  const { post, isFetching } = usePostQuery({ url: '/assign/tag' })
  return { assignTag: post, isFetching }
}

export const useCreateTag = () => {
  const { post, isFetching } = usePostQuery({ url: '/tags' })
  return { createTag: post, isFetching }
}

export const useRemoveTag = () => {
  const { post, isFetching } = usePostQuery({ url: '/remove/tag', method: 'DELETE' })
  return { removeTag: post, isFetching }
}
